import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const userString = localStorage.getItem("user");
  const token = localStorage.getItem("token");

  if (!token || !userString || userString === "undefined") {
    return <Navigate to="/login" />;
  }

  try {
    const user = JSON.parse(userString);
    
    // If user hasn't completed onboarding, redirect to onboarding
    if (!user.onboardingCompleted || !user.organizations?.length) {
      return <Navigate to="/onboarding" />;
    }
    
    return children;
  } catch (error) {
    // If user data is corrupted, redirect to login
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    return <Navigate to="/login" />;
  }
};

export default PrivateRoute;
